import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { tenantService } from '@/services/http/tenantService'

export const useTenantConfig = () => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['tenantConfig'],
    queryFn: () => tenantService.getConfigs(),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao buscar configurações do tenant',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      config: data,
      isLoading,
      refetchTenantConfig: refetch,
    }
  }

  return {
    config: null,
    isLoading,
    refetchTenantConfig: refetch,
  }
}
